import { render, staticRenderFns } from "./ExhibitionCard.vue?vue&type=template&id=58d35c1f&scoped=true"
import script from "./ExhibitionCard.vue?vue&type=script&lang=ts"
export * from "./ExhibitionCard.vue?vue&type=script&lang=ts"
import style0 from "./ExhibitionCard.vue?vue&type=style&index=0&id=58d35c1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d35c1f",
  null
  
)

export default component.exports